<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-10 17:57:03
 * @LastEditTime: 2020-09-17 16:30:13
 * @Description: 储罐租借页面
-->
<template>
  <div class="container">
    <div class="handle-wrapper">
      <!-- <Input
        v-model="searchText"
        search
        placeholder="搜索储罐租借..."
        @on-enter="searchSacTankRental"
        style="width: 250px; margin-right: auto;"
      >
        <Button slot="append" icon="ios-search" @click="searchSacTankRental"></Button>
      </Input>-->
      <span>共{{totalRows}}条</span>
      <Page
        :total="totalRows"
        :page-size="10"
        @on-change="loadSacTankRental"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button type="primary" @click="$refs.AddTankRentalDrawer.openDrawer()">新增储罐租借</Button>
    </div>
    <div class="table-wrapper">
      <Table :loading="tableLoading" :columns="columns" :data="tableData" width='950'></Table>
    </div>
    <AddTankRentalDrawer ref="AddTankRentalDrawer" :customerId="customerId" />
  </div>
</template>

<script>
import AddTankRentalDrawer from "./AddTankRentalDrawer";
import { mapState, mapActions, mapGetters } from "vuex";
import dayjs from "dayjs";

export default {
  name: "TankRental",
  components: { AddTankRentalDrawer },
  props: ["customerId"],
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      columns: [
        {
          title: "公司",
          key: "company",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.AddTankRentalDrawer.openDrawer(params.row);
                    },
                  },
                },
                params.row.company.name
              ),
            ]);
          },
        },
        {
          title: "容量/吨",
          key: "weight",
          align: "center",
          width: 90,
        },
        {
          title: "数量/个",
          key: "quantity",
          align: "center",
          width: 90,
        },
        {
          title: "金额/元",
          key: "price",
          align: "center",
          width: 90,
        },
        {
          title: "借用日期",
          key: "rentalTime",
          align: "center",
          render: (h, params) => {
            return h("span", dayjs(params.row.rentalTime).format("YYYY-MM-DD"));
          },
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.tankRental.tankRentalList,
      totalRows: (state) => state.tankRental.totalCounts,
    }),
  },
  methods: {
    ...mapActions({
      getTankRentalList: "tankRental/getTankRentalListAction",
    }),
    async loadSacTankRental(page) {
      if (page) this.page = page - 1;
      let api = { skip: this.page * 10, limit: 10, customer: this.customerId };
      if (this.searchText) api.searchText = this.searchText;

      try {
        this.tableLoading = true;
        await this.getTankRentalList(api);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchSacTankRental() {
      this.page = 0;
      this.loadSacTankRental();
    },
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 950px
  height 48px
  display flex
  justify-content flex-end

.table-wrapper
  height calc(100% - 48px)


.container
  width 100%
  margin-top 0 !important
</style>
